import React, { FC } from 'react';

import { StyledStatusBadgeWrapper } from './styled';

// TODO: будет привязано к реальным значениям статуса из бэка
export type StatusBadgeType = 'waiting' | 'success' | 'alert' | 'alertDark' | 'closed' | 'processing' | 'buyout';

type TProps = {
    children: React.ReactNode;
    theme?: StatusBadgeType;
};

export const StatusBadge: FC<TProps> = ({ theme = 'waiting', children }) => {
    return (
        <StyledStatusBadgeWrapper typeTheme={theme}>
            <div>{children}</div>
        </StyledStatusBadgeWrapper>
    );
};
